import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const WorldIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path d="M20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20C16.4 20 20 16.4 20 12ZM11 13C11 12.7 11 12.3 11 12C11 11.7 11 11.3 11 11H13C13 11.3 13 11.7 13 12C13 12.3 13 12.7 13 13H11ZM12.6 15C12.4 15.6 12.2 16.2 12 16.8C11.7 16.2 11.5 15.6 11.4 15H12.6ZM6 12C6 11.7 6 11.3 6.1 11H9C9 11.3 9 11.7 9 12C9 12.3 9 12.7 9 13H6.1C6 12.7 6 12.3 6 12ZM11.4 9C11.6 8.4 11.8 7.8 12 7.2C12.3 7.8 12.5 8.4 12.6 9H11.4ZM15 11H17.9C18 11.3 18 11.7 18 12C18 12.3 18 12.7 17.9 13H15C15 12.7 15 12.3 15 12C15 11.7 15 11.3 15 11ZM17.2 9H14.7C14.5 8.1 14.2 7.2 13.8 6.3C15.2 6.7 16.4 7.7 17.2 9ZM10.2 6.3C9.8 7.2 9.5 8.1 9.3 9H6.8C7.6 7.7 8.8 6.7 10.2 6.3ZM6.8 15H9.3C9.5 15.9 9.8 16.8 10.2 17.7C8.8 17.3 7.6 16.3 6.8 15ZM13.8 17.7C14.2 16.8 14.5 15.9 14.7 15H17.2C16.4 16.3 15.2 17.3 13.8 17.7Z" />
    </Icon>
  );
};
